export const extractTextFromDelta = (delta) => {
  if (!Array.isArray(delta)) {
    return [];
  }
  return delta
    .filter((op) => typeof op.insert === "string") // Keep only string inserts
    .map((op) => op.insert); // Extract the text
};
